const productListData = [
    {
        id: 1,
        image: require('@/assets/images/products/1.jpg'),
        name: 'Gray belt watch',
        text: 'Sed ut perspiciatis unde omnis iste.',
        date: '22/05/2017',
        amount: '$521',
        units: 5841,
        stock: 25
    },
    {
        id: 2,
        image: require('@/assets/images/products/2.jpg'),
        name: 'Riverston Glass Chair',
        text: 'natus error sit voluptatem doloremque.',
        date: '28/03/2017',
        amount: '$210',
        units: 841,
        stock: 85
    },
    {
        id: 3,
        image: require('@/assets/images/products/3.jpg'),
        name: 'Trex Outdoor Furniture Cape',
        text: 'Nemo enim ipsam voluptatem quia.',
        date: '22/05/2017',
        amount: '$652',
        units: 120,
        stock: 25
    },
    {
        id: 4,
        image: require('@/assets/images/products/4.jpg'),
        name: '3 color belt watch',
        text: 'Dolor sit consec te imperdiet iaculis.',
        date: '11/05/2017',
        amount: '$85',
        units: 320,
        stock: 65
    },
    {
        id: 5,
        image: require('@/assets/images/products/5.jpg'),
        name: 'Classic Company watch',
        text: 'Quis autem vel eum iure reprehenderit qu.',
        date: '18/04/2017',
        amount: '$8512',
        units: 201,
        stock: 79
    },
    {
        id: 6,
        image: require('@/assets/images/products/6.jpg'),
        name: 'Shine Company Chair',
        text: 'At vero eos et accusamus et iusto odio.',
        date: '02/03/2017',
        amount: '$521',
        units: 321,
        stock: 25
    },
    {
        id: 7,
        image: require('@/assets/images/products/4.jpg'),
        name: 'Outdoor Furniture Cape',
        text: 'Quis autem vel eum iure te imperdiet.',
        date: '12/05/2017',
        amount: '$22',
        units: 5110,
        stock: 95
    },
    {
        id: 8,
        image: require('@/assets/images/products/1.jpg'),
        name: 'black color lamp',
        text: 'At vero eos et accusamus et iusto odio.',
        date: '18/04/2017',
        amount: '$98',
        units: 556,
        stock: 45
    },
    {
        id: 9,
        image: require('@/assets/images/products/2.jpg'),
        name: 'Gray belt watch',
        text: 'Sed ut perspiciatis unde omnis iste.',
        date: '22/05/2017',
        amount: '$521',
        units: 5841,
        stock: 25
    },
    {
        id: 10,
        image: require('@/assets/images/products/3.jpg'),
        name: 'Riverston Glass Chair',
        text: 'natus error sit voluptatem doloremque.',
        date: '28/03/2017',
        amount: '$210',
        units: 841,
        stock: 85
    },
];

export { productListData };
